var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        name: "base-modal",
        centered: "",
        "hide-header-close": _vm.hideClose,
        size: _vm.size,
        "hide-footer": !_vm.footerSlotExists,
        "no-close-on-backdrop": _vm.noCloseOnBackdrop,
        "no-close-on-esc": _vm.noCloseOnScape,
        "body-class": _vm.bodyClass
      },
      on: {
        shown: function($event) {
          return _vm.$emit("shown", $event)
        },
        hidden: function($event) {
          return _vm.$emit("hidden", $event)
        },
        hide: function($event) {
          return _vm.$emit("hide")
        }
      },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _vm.title
        ? _c("h5", {
            class: { "text-center": !_vm.titleAlignLeft },
            domProps: { innerHTML: _vm._s(_vm.title) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c5948e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c5948e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModal.vue
// module id = 1585
// module chunks = 116